import { createGlobalStyle } from 'styled-components';

import AllianceWoff from './AllianceNo2-Regular.woff';
import AllianceWoff2 from './AllianceNo2-Regular.woff2';


export default createGlobalStyle`
    @font-face {
      font-family: 'Alliance No.2';
      src: local('AllianceNo2-Regular'), local('AllianceNo2-Regular'),
      url(${AllianceWoff2}) format('woff2'),
      url(${AllianceWoff}) format('woff');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
    
`;